import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from './adal.service';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { AdalService } from './adal.service';
var AdalGuard = /** @class */ (function () {
    function AdalGuard(adalService) {
        this.adalService = adalService;
    }
    AdalGuard.prototype.canActivate = function (route, state) {
        return this.adalService.userInfo.authenticated;
    };
    AdalGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    AdalGuard = __decorate([ __metadata("design:paramtypes", [AdalService])
    ], AdalGuard);
AdalGuard.ɵfac = function AdalGuard_Factory(t) { return new (t || AdalGuard)(ɵngcc0.ɵɵinject(ɵngcc1.AdalService)); };
AdalGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AdalGuard, factory: function (t) { return AdalGuard.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AdalGuard, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.AdalService }]; }, null); })();
    return AdalGuard;
}());
export { AdalGuard };

